import controller from './vd-avatar.controller'
import template from './vd-avatar.html'

const AvatarComponent = {
  bindings: {
    entity: '<',
  },
  controller,
  template,
}

export default AvatarComponent
